import { cn } from '@/frontend/utils'

export const LightCard = ({
  children,
  className,
  ...props
}: {
  children: React.ReactNode
  className?: string
} & React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={cn(
        'h-fit rounded-xl border border-borderPrimary bg-backgroundPrimary p-6',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}
